"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxHeight = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
exports.MaxHeight = (0, react_1.forwardRef)(({ children, className }, forwardedRef) => {
    const maxHeightRef = (0, app_1.useMaxHeight)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: className, ref: (r) => {
            maxHeightRef.current = r;
            if (typeof forwardedRef === 'function') {
                forwardedRef(r);
            }
        } }, { children: children })));
});
